import { useEffect, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { onUseEffect } from "components/generators/filtersGenerator";
import { useSearchParams } from "react-router-dom";
import qs from "qs";
import { FilterField } from "layout/TableConstructor/types";
import Filters from "components/Filters";

type ListFiltersProps = {
  form: UseFormReturn;
  filters: FilterField<object>[];
};

const ListFilters = ({ form, filters }: ListFiltersProps) => {
  const { reset } = form;
  const [searchParams] = useSearchParams();
  const query = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);

  useEffect(() => {
    onUseEffect(filters, reset, query);
  }, [query]);

  return (
    <Filters
      form={form}
      filters={filters}
    />
  );
};

export default ListFilters;
